import { the_user } from '../me/login';
import { $api } from '../y/api';
import { YId } from '../y/types';
import { MInboxItem } from './m-inbox';

declare module './c-user' {
    interface CLoginUser {
        subscriptions: CSubscription[];
        event_tag_ids: YId[];
        saved_event_ids: YId[];
        inbox: MInboxItem[];
    }
}

export function meSaveEvent(id: YId) {
    return $api.POST(`me/saved_event/${id}`).then(() => {
        the_user!.saved_event_ids.push(id);
    });
}

export function meUnsaveEvent(id: YId) {
    return $api.DELETE(`me/saved_event/${id}`).then(() => {
        the_user!.saved_event_ids = the_user!.saved_event_ids.filter(i => i != id);
    });
}